import { DatePipe, NgFor, NgIf, NgSwitch, NgSwitchCase } from '@angular/common';
import { Component } from '@angular/core';
import { CompetitionEvent, EventType } from 'src/app/models/competitionEvent';
import { CompetitionEventsService } from 'src/app/services/competition-events.service';

@Component({
    selector: 'app-competition-events',
    templateUrl: './competition-events.component.html',
    imports: [NgIf, NgSwitch, NgSwitchCase, NgFor, DatePipe]
})
export class CompetitionEventsComponent {
    private currentPage: number = 1;
    private itemsPerPage: number = 5;
    public EventType = EventType;
    public events: CompetitionEvent[] = [];
    public endOfList = false;

    constructor(private competitionEventService: CompetitionEventsService) {
        this.loadEvents();   
    }

    public loadMoreEvents(): void {        
        this.currentPage += 1;
        this.loadEvents();
    }

    private loadEvents() {
        this.competitionEventService.getUpcomingEvents(this.currentPage, this.itemsPerPage).subscribe(events => {
            this.endOfList = events.length < this.itemsPerPage;
            this.events.push(...events);
        });
    }
}